import { BaseApi } from './base';

class CoursesApi extends BaseApi {
  constructor() {
    super('courses');
  }

  getCourses() {
    return this.get('');
  }

  getProgram(id) {
    return this.get(`/${id}`);
  }

  uploadHomeWork(data) {
    return this.post('/homework', data);
  }

  removeHomeWork(id) {
    return this.post('/delete/homework', { id });
  }
}

export default new CoursesApi();
